/**
 * Datatable definition for Contacts table.
 */

var app_contacts_table = $('#app-contacts-table');

if (app_contacts_table.length) {
    var contacts_url = app_contacts_table.attr('data-contact-url');
    var data_table_order=[ 0, "asc" ];
    function initializeContactsTable() {
        window.app_contacts_table.DataTable({
            ajax: {
                url: contacts_url,
                dataSrc: 'data'
            },
            columns: [
                {data: 'contact_name'},
                {data: 'phone'},
                {data: 'email'},
                {data: 'role'},
                {data: 'slug'}
            ],
            destroy: true,
            order: data_table_order,
            pageLength: user_entries,
            "columnDefs": [{
                "targets": 4,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                        '<a href="' + contacts_url + '/' +
                        cellData + '/edit' +
                        '" role="button" class="btn btn-success btn-sm">' +
                        '<i class="fa fa-pencil"></i> Edit' +
                        '</a>';
                    if(typeof table_editable === 'undefined'){
                        table_editable = true;
                    }
                    if(table_editable){
                        html += '<a href="javascript:void(0)" onclick="deleteContact(\'' + contacts_url + '/' +
                            cellData + '/destroy' + '\')" role="button" class="btn btn-danger btn-sm">' +
                            '<i class="fa fa-trash-o"></i> Delete' +
                            '</a>';
                        if(rowData.default == '0')
                        {
                            html += '<a href="javascript:void(0)" onclick="setAsDefault(\'' + contacts_url + '/' +
                                cellData + '/setasdefault' + '\')" role="button" class="btn btn-warning btn-sm">' +
                                '<i class="fa fa-star-o"></i> Set as default' +
                                '</a>';
                        }else{
                            html += '<a href="javascript:void(0)" onclick="unsetAsDefault(\'' + contacts_url + '/' +
                                cellData + '/unsetasdefault' + '\')" role="button" class="btn btn-info btn-sm">' +
                                '<i class="fa fa-star"></i> Unset as default' +
                                '</a>';
                        }
                    }
                    html += '</div>';
                    html += '</div>';
                    $(td).html(html);
                }
            }]
        });
    }
    $('#app-contacts-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-contacts-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    function setAsDefault(urlVar){
        $.ajax({
            url: urlVar,
            dataType: 'json',
            success: function (response) {
                if (typeof(response.error) === 'boolean') {
                    global_notification('warning', response.message);
                }
                else {
                    global_notification('success', 'Contact checked as default..');
                }
                initializeContactsTable();
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    function unsetAsDefault(urlVar){
        $.ajax({
            url: urlVar,
            dataType: 'json',
            success: function (response) {
                if (typeof(response.error) === 'boolean') {
                    global_notification('warning', response.message);
                }
                else {
                    global_notification('success', 'Contact unchecked as default..');
                }
                initializeContactsTable();
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    function deleteContact(urlVar) {
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        dataType: 'json',
                        success: function (response) {
                            if (typeof(response.error) === 'boolean') {
                                global_notification('warning', response.message);
                            }
                            else {
                                global_notification('success', 'Contact deleted.');
                            }
                            initializeContactsTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });
    }

    initializeContactsTable();
}
